<template>
    <div>
        <table class="table is-fullwidth is-hoverable">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ translate("common.competitor") }}</th>
                    <th>{{ translate("event_ranking.score") }}</th>
                    <th>{{ translate("event_ranking.won_matches") }}</th>
                    <th>{{ translate("event_ranking.lost_matches") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="competitor in props.generatedRanking.competitors" :key="competitor.competitorId">
                    <td>{{ competitor.place }}</td>
                    <td class="clarity-mask">{{ competitor.firstName }} {{ competitor.lastName }}</td>
                    <td>{{ competitor.score }}</td>
                    <td>{{ competitor.wonMatches }}</td>
                    <td>{{ competitor.lostMatches }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
    import { GeneratedRankingResponse } from "../Api/eventRankings";
    import { translate } from "../Common/translations";

    const props = defineProps<{
        generatedRanking: GeneratedRankingResponse;
    }>();
</script>

<style scoped></style>
